export default __webpack_public_path__ + "static/B42-15ddf162b8818d5cbe57e9ddfe085137.png";